import React, { useCallback, useMemo, useState } from 'react';

import { parseReceivedNotifications } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import InfoBox from 'containers/distributors/distributor-details/InfoBox';
import { Message } from 'components';
import { Box, Typography } from '@mui/material';

const MessagesSection = ({ user }) => {
    const [expandedMessageId, setExpandedMessageId] = useState(null);
    const handleToggleExpand = useCallback(
        id => e => {
            setExpandedMessageId(prevState => (prevState === id ? null : id));
        },
        []
    );

    const receivedMessages = useMemo(
        () => parseReceivedNotifications(user?.receivedNotifications),
        [user]
    );

    const hasMessages = Array.isArray(receivedMessages) && receivedMessages.length > 0;

    return (
        <InfoBox title={texts.MESSAGES} disableLeftColumn>
            {!hasMessages ? (
                <Box textAlign="center">
                    <Typography>{texts.NO_MESSAGE}</Typography>
                </Box>
            ) : (
                <Box display="flex" flexDirection="column" gap={2}>
                    {receivedMessages.map(message => (
                        <Message
                            key={message.id}
                            id={message.id}
                            expanded={expandedMessageId === message.id}
                            onToggleExpand={handleToggleExpand(message.id)}
                            title={message.title}
                            content={message.content}
                            type={message.type}
                        />
                    ))}
                </Box>
            )}
        </InfoBox>
    );
};

export default React.memo(MessagesSection);
